import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { QuickFixStepModel } from '@shared/isf-mutual/interfaces';
import { IsfOcrQuickFixService } from '@shared/isf-mutual/services';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-isf-ocr-quick-fix-header',
  templateUrl: './isf-ocr-quick-fix-header.component.html',
  styleUrls: ['./isf-ocr-quick-fix-header.component.scss'],
})
export class IsfOcrQuickFixHeaderComponent implements OnInit {
  @Output() public clearAll: EventEmitter<void> = new EventEmitter<void>();
  @Output() public quickFix: EventEmitter<void> = new EventEmitter<void>();

  public stepsToFix: QuickFixStepModel[] = [];

  private destroy$: ReplaySubject<void> = new ReplaySubject<void>();

  constructor(private isfOcrQuickFixService: IsfOcrQuickFixService) {}

  ngOnInit(): void {
    this.isfOcrQuickFixService.stepsChanged$.pipe(takeUntil(this.destroy$)).subscribe((stepsState) => {
      const stepsToFix = stepsState.current;
      this.stepsToFix = stepsToFix;
    });
  }

  public onClearAll() {
    this.clearAll.emit();
  }

  public onQuickFix() {
    this.quickFix.emit();
  }

  public get isShowQuickFix(): boolean {
    return !!this.stepsToFix.length;
  }
}
